import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, List, Typography } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function Sales() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const sales = (notifications || []).find(n => n.type === ENotificationType.SALES);
  if (!sales?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.SALES}`}>
      <List.Item extra={<Badge count={sales?.quantity || 0} color='blue' showZero />}>
        <Typography.Text strong>Vendas realizadas</Typography.Text>
      </List.Item>
    </Link>
  );
}
